export default "__VITE_ASSET__C0aua1v1__"